/* eslint-disable camelcase */

export function hentAlleDatoer(aktiviteter = [], lunsj_dager = [], middag_dager = []) {
    const datoSet = new Set([
        ...aktiviteter.map(a => a.dato),
        ...lunsj_dager.map(d => d.dato),
        ...middag_dager.map(d => d.dato)
    ]);

    return [...datoSet].filter(Boolean).sort((a, b) => a - b);
}
